module.exports = __webpack_public_path__ + "static/media/insulation_allImpact_60yd_n.d064d5ce.csv";